import React from "react";
import { Navigate } from "react-router-dom";
const ProtectedRoute = ({ children }) => {
  const authRoute = localStorage.getItem("CMS_STOKEN");

  if (!authRoute) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoute;
